export let dataProps = {
    id: 0,
    holiday_date: '',
    holiday_name: '',
    holiday_type: true,
    applicable_to_production_as_well: true,
    applied_to_religion: 0
}


// WEBPACK FOOTER //
// ./src/store/modules/holidayMaster/properties.js